import { render, staticRenderFns } from "./edit.submission-contents.page.vue?vue&type=template&id=b14a4788&"
import script from "./edit.submission-contents.page.vue?vue&type=script&lang=js&"
export * from "./edit.submission-contents.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports